import React from 'react';
import {View, Image, TouchableOpacity} from '@applane/react-core-components';
import {getRenderComponent} from '@applane/react-input-wrapper';

const NumberSelector = props => {
  let {
    onInc,
    onDec,
    incIcon,
    decIcon,
    renderInputSelector,
    inputSelectorContainerStyle,
    inputSelectorMultiIconContainerStyle,
    inputSelectorMultiIconStyle,
  } = props;
  if (renderInputSelector) {
    return getRenderComponent(renderInputSelector, props);
  }
  if (!incIcon && !decIcon) {
    return null;
  }
  return (
    <View style={inputSelectorContainerStyle}>
      <TouchableOpacity
        style={inputSelectorMultiIconContainerStyle}
        onPress={onInc}>
        <Image style={inputSelectorMultiIconStyle} source={incIcon} />
      </TouchableOpacity>
      <TouchableOpacity
        style={inputSelectorMultiIconContainerStyle}
        onPress={onDec}>
        <Image style={inputSelectorMultiIconStyle} source={decIcon} />
      </TouchableOpacity>
    </View>
  );
};

NumberSelector.defaultProps = {
  inputSelectorContainerStyle: {
    paddingLeft: 8,
    paddingRight: 8,
    justifyContent: 'center',
  },
};

export default NumberSelector;
